import {gettext} from 'topmeteo/utils/i18n';

import MarkSafe from '../../../general/components/MarkSafe';

const Message = gettext('We have made a preselection of favorites based on your interests. <span class="desktop-only">Changes could be made at any time by using the <span class="icon-favourite"></span> star symbol.</span>');

const PreselectionMessage = () => (
    <MarkSafe Element="p" html={Message} />
);

export default PreselectionMessage;
